import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDetalleMutuo } from '../../../../context/mutuoContext';
import { Card, Grid2, Typography } from '@mui/material';
import MButton from '../../../../components/inputs/yup/materialui/mButton';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { useForm } from 'react-hook-form';
import { desactivarMutuo } from '../../services/serviceDesactivarMutuo';
import { desactivar as validarDesactivar } from '../../services/serviceDesactivarMutuo';
import { StatusCode } from '../../../../utils/enums';
import { useToast } from '../../../../hooks/useToast';

export interface RespuestaDesactivarMutuoDTO {
    tieneDividendosGenerados: boolean;
    tieneDividendosRecaudados: boolean;
    estado: string;
}

interface DesactivarMutuoProps {
    idMutuo: number;
    onVolver: () => void;
}

const DesactivarMutuo: React.FC<DesactivarMutuoProps> = ({ idMutuo, onVolver }) => {

    const [modalConfirmacion, setModalConfirmacion] = useState({
        show: false,
        title: '',
        message: '',
        metodo: () => { },
    });

    type FormData = {};
    const { formState: { errors, isDirty, isValid }, control } = useForm<FormData>();
    const { addToast } = useToast();

    const handleDesactivarButtonClick = async () => {

        const validationResponse = await validarDesactivar(idMutuo);
        const validationData: RespuestaDesactivarMutuoDTO = validationResponse.data;

        let confirmationMessage = "";
        const confirmationTitle = "Desactivar mutuo";

        if (validationData.tieneDividendosGenerados && validationData.tieneDividendosRecaudados) {
            confirmationMessage = "¿Está seguro de que desea desactivar el mutuo aún cuando este posee dividendos generados y recaudados?";
        } else if (validationData.tieneDividendosGenerados && !validationData.tieneDividendosRecaudados) {
            confirmationMessage = "¿Está seguro de que desea desactivar el mutuo aún cuando este posee dividendos generados?";
        } else if (!validationData.tieneDividendosGenerados && !validationData.tieneDividendosRecaudados) {
            confirmationMessage = "¿Está seguro de que desea desactivar el mutuo?";
        } else if (!validationData.tieneDividendosGenerados && validationData.tieneDividendosRecaudados) {
            confirmationMessage = "¿Está seguro de que desea desactivar el mutuo aún cuando este posee dividendos recaudados?";
        } else {
            confirmationMessage = "¿Está seguro de que desea desactivar el mutuo?";
        }

        const confirmAction = async () => {
            await executeDesactivacion();
        };

        setModalConfirmacion({
            show: true,
            title: confirmationTitle,
            message: confirmationMessage,
            metodo: confirmAction,
        });

    };

    const executeDesactivacion = async () => {
        const resp = await desactivarMutuo(idMutuo); 
        if (resp.status === StatusCode.NoContent) {
            addToast({
                mostrar: true,
                titulo: 'Éxito',
                tipo: 'Success',
                mensaje: 'Mutuo desactivado correctamente.',
            });
            onVolver(); 
        }
    };

    return (
        <>
            <ConfirmationModal
                onHide={() =>
                    setModalConfirmacion({
                        ...modalConfirmacion,
                        show: false,
                    })
                }
                onConfirm={modalConfirmacion.metodo}
                show={modalConfirmacion.show}
                title={modalConfirmacion.title}
                message={modalConfirmacion.message}
            />

            <Card sx={{ mb: 2, backgroundcolor: 'white' }} raised>
                <Grid2 container alignItems="center" spacing={2} sx={{ mb: 2, mt: 2, p: 2 }}>
                    <Grid2 size={2}>
                        <Typography className='card-title' variant="h6">Desactivar mutuo</Typography>
                    </Grid2>
                    <Grid2 container spacing={1} size={10} sx={{ textAlign: "right", justifyContent: 'flex-end' }}>
                        <MButton
                            variant='contained'
                            color='error'
                            startIcon={<DeleteForeverIcon />}
                            onClick={onVolver}
                        >
                            Cancelar
                        </MButton>

                        <MButton
                            variant="contained"
                            startIcon={<BlockIcon />}
                            onClick={handleDesactivarButtonClick}
                        >
                            Desactivar
                        </MButton>

                    </Grid2>
                </Grid2>
            </Card>
        </>
    );
};

export default DesactivarMutuo;